import styles from '../EnhancedMedia.scss';

import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { MaterialIcon } from '../../MaterialIcon/MaterialIcon';

type HtmlAttributes = React.ButtonHTMLAttributes<HTMLButtonElement>;

const PlayPauseButton: React.FC<{paused?: boolean; isAmbient?: boolean} & WithTranslation & Pick<HtmlAttributes, Exclude<keyof HtmlAttributes, 'title'>>> = ({
  t, i18n, tReady, paused, isAmbient, ...props
}) => (
  <button title={t(paused ? 'play' : 'pause')} {...props}>
    <MaterialIcon icon={paused ? 'play_circle_outline' : 'pause_circle_outline'} />
    {isAmbient && <span className={styles.controlNoSoundInfo}>{t('no-sound')}</span>}
  </button>
);

const Wrapped = withTranslation()(PlayPauseButton);
export { Wrapped as PlayPauseButton };
